import { ConfigType } from './type';

export const CONFIG: ConfigType = {
  // ENV
  environment: 'dev',
  VITE_CURRENT_ENV: {
    isLocal: false,
    isDev: true,
    isStaging: false,
    isMock: false,
    isProd: false,
    isWeb: true,
    isMobile: false,
  },
  VITE_APP_DOMAINS: {
    POINTPAY: 'https://dev-pointpay.pointcraft.io',
    POS: 'https://dev-dashboard.pncf.app',
    POINTPAY_PUBLIC: 'https://pointpay-public-dev.web.app',
    MANAGEMENT: 'https://pointcraft-manager-dev.web.app',
  },

  // API
  // VITE_HOST_API: 'https://dev-api.pncf.app/b',
  VITE_HOST_API: 'https://pncf-dev.ngrok.io',
  // VITE_PUBLIC_API points at the deployed dev backend load balancer (`/b/*`),
  // not the developer ngrok tunnel, because the deployed pointpay-public dev
  // site reads it for the public experiences guest API (PLAN.md §16.1, DEC-02).
  // Verified consumers: offline-demo availability policy (host is not
  // production-like and dev-api.pncf.app already appears via VITE_ATH_API),
  // Manager Sentry trace-propagation targets (same origin already present),
  // the Manager debug env tab (display only) and SystemStore.basePublicUrl
  // (read only by the POS debug tab and the diagnostics host allowlist, whose
  // origin set is unchanged). POS request routing uses VITE_HOST_API, which is
  // deliberately left on the tunnel.

  // DEV not local
  // VITE_PUBLIC_API: 'https://dev-api.pncf.app/b',
  // VITE_ATH_API: 'https://dev-api.pncf.app/f/api',
  // VITE_ATH_API_PUBLIC: 'https://dev-api.pncf.app/f/api',
  VITE_PUBLIC_API: 'https://pncf-dev.ngrok.io',
  VITE_ATH_API: 'https://pncf-ath-dev.ngrok.io/api',
  VITE_ATH_API_PUBLIC: 'http://0.0.0.0:3078/api',
  // FIREBASE
  VITE_FIREBASE_API_KEY: 'AIzaSyAyz8Ty4FCi6d_By6vVPxJTJ7qmYsHIbJo',
  VITE_FIREBASE_AUTH_DOMAIN: 'pointcraft-inc-dev.firebaseapp.com',
  VITE_FIREBASE_PROJECT_ID: 'pointcraft-inc-dev',
  VITE_FIREBASE_STORAGE_BUCKET: 'pointcraft-inc-dev.firebasestorage.app',
  VITE_FIREBASE_MESSAGING_SENDER_ID: '856652746129',
  VITE_FIREBASE_APPID: '1:484162777977:web:ece73678d6a18aa2a935a8',
  VITE_FIREBASE_MEASUREMENT_ID: '',
  VITE_FIREBASE_REALTIME_DB_URL: 'https://pointcraft-inc-dev-default-rtdb.firebaseio.com',
  VITE_STRIPE_PUBLISHABLE_KEY:
    'pk_test_51Py6DYCR0GreNaAF0Jh35mI1l8pm5UsBms2eGaBeRc6y7Q7RrQoZ4GlA0jOexxbndmDPYnNgOwCYW0eRQjerAR9100z6p50Mhp',
  VITE_TILLED_PUBLISHABLE_KEY:
    'pk_mJb0BbXLxHedotoe7v7KQDP3gvCfmsvcjZmt1IUWzzr7unaiSvbt0De0supLmZRFenI7Cfy75WHtf69oLXRen2jJAccqvh0pKW5P',
  // MSC
  VITE_ASSETS_API: 'none',
  VITE_APP_VERSION: '8.1.14',
  VITE_MAIN_TEST_ACCOUNT_NUMBER: '',
  VITE_CUSTOMER_SERVICE_PHONE: '+1 (612) 473-5556',
  VITE_CUSTOMER_SERVICE_EMAIL: 'dev-support@point-craft.com',
  VITE_DEFAULT_TERMINAL_READER_LOCATION_ID: 'tml_FuR9ywczjnwKqt',
  VITE_SITE_ID: 'point_of_sale', // Default to POS, can be overridden by env var
  // sentry will consume to many replays in use in dev
  VITE_SENTRY_DSN: '',
  VITE_SENTRY_ORG: 'pointcraft-inc',
  VITE_SENTRY_PROJECT: 'pointcraft-frontend',
  VITE_MANAGER_SENTRY_DSN:
    'https://82a03e3ec2ebd1f8d94d1ce8ecaa7fee@o4507762364448768.ingest.us.sentry.io/4512036329357312',
  VITE_MANAGER_SENTRY_ORG: 'pointcraft-inc',
  VITE_MANAGER_SENTRY_PROJECT: 'pointcraft-manager',
  VITE_GOOGLE_MAPS_API_KEY: 'AIzaSyD9X4W5-UlwQWvPrqKbD0mv7Ku1wFGoFxg', // Add your Google Maps API key here
  VITE_RECAPTCHA_SITE_KEY: '6Le9toIsAAAAADldynrSmWPoD5LYvx_hUPp2znB0',
  VITE_JOTFORM_RECAPTCHA_SITE_KEY: '6LcNm8YtAAAAAKDYAGPnoQW1U3R6XT97UeTtfaJM',
  VITE_RECAPTCHA_ENABLED: true,
};
